/**
 * ChatNaoLidasWidget — o Chat Pharu (ADR-0077) na Visão Geral: quantas
 * CONVERSAS têm mensagem não lida (o mesmo número do botão do cabeçalho e do
 * menu) e quantas menções a você esperam. O widget "WhatsApp não lidas" é
 * outra coisa: o atendimento de clientes pelo WhatsApp.
 */
import React from "react";
import { Link } from "react-router-dom";

import { conversasComNaoLidas } from "../../../services/notificacoesDoChat";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "chat_nao_lidas",
  label: "Chat — conversas com mensagem nova",
  descricao: "Conversas do Chat Pharu com mensagem não lida e menções a você.",
  categoria: "Pendencias",
  permissoes: ["chat:view"],
  tamanho_default: "S",
  essencial: false,
};

const dados = (p) => (p && p.data !== undefined ? p.data : p);

export async function fetchData(request) {
  const [naoLidas, mencoes] = await Promise.all([
    request("/api/chat/nao-lidas", { silentError: true }),
    request("/api/chat/mencoes", { silentError: true }),
  ]);
  return {
    conversas: conversasComNaoLidas(dados(naoLidas)?.por_conversa),
    mencoes: Number(dados(mencoes)?.total) || 0,
  };
}

export function Widget({ dados: d }) {
  const conversas = d?.conversas ?? 0;
  const mencoes = d?.mencoes ?? 0;
  return (
    <>
      <CardBody>
        <KpiValor style={{ color: conversas > 0 ? "var(--info-text)" : undefined }}>{conversas}</KpiValor>
        <KpiSub>
          {conversas === 0
            ? "Nenhuma conversa com mensagem nova."
            : mencoes > 0
              ? `${conversas === 1 ? "conversa" : "conversas"} com mensagem nova · ${mencoes} ${mencoes === 1 ? "menção" : "menções"} a você`
              : `${conversas === 1 ? "conversa" : "conversas"} com mensagem nova`}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/chat">Abrir o Chat</LinkLight>
      </CardFooter>
    </>
  );
}
